import PropTypes from 'prop-types'

import {useUtils} from '../../hooks/useUtils.js'
import {PANEL_FINANCING_VERSION} from '../config.js'
import {PanelFinancingContentB2C} from './PanelFinancingContentB2C.js'
import {PanelFinancingContentC2C} from './PanelFinancingContentC2C.js'
import {PanelFinancingSimplifiedContent} from './PanelFinancingSimplifiedContent.js'

export const PanelFinancingContentLayout = ({
  ad,
  isProfessional,
  financingData,
  onCalculatorChange = () => {},
  onContactSellerCtaClick,
  vehicleInfo = {}
}) => {
  const {getPanelFinancingVersion} = useUtils()

  if (Object.values(financingData).length < 0) return <></>

  const panelFinancingVersion = getPanelFinancingVersion({
    isProfessional,
    loanCalculations: financingData
  })

  return (
    <>
      {panelFinancingVersion === PANEL_FINANCING_VERSION.B2C && (
        <PanelFinancingContentB2C
          ad={ad}
          isProfessional={isProfessional}
          financingData={financingData}
          onCalculatorChange={onCalculatorChange}
          vehicleInfo={vehicleInfo}
        />
      )}
      {panelFinancingVersion === PANEL_FINANCING_VERSION.C2C && (
        <PanelFinancingContentC2C
          ad={ad}
          isProfessional={isProfessional}
          financingData={financingData}
          onCalculatorChange={onCalculatorChange}
          vehicleInfo={vehicleInfo}
        />
      )}
      {panelFinancingVersion === PANEL_FINANCING_VERSION.SIMPLIFIED && (
        <PanelFinancingSimplifiedContent
          ad={ad}
          isProfessional={isProfessional}
          financingData={financingData}
          onContactSellerCtaClick={onContactSellerCtaClick}
        />
      )}
    </>
  )
}

PanelFinancingContentLayout.propTypes = {
  ad: PropTypes.object,
  isProfessional: PropTypes.string,
  financingData: PropTypes.object,
  onCalculatorChange: PropTypes.func,
  onContactSellerCtaClick: PropTypes.func,
  vehicleInfo: PropTypes.object
}
